import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-button-group-example',
  templateUrl: './button-group.component.html',
})
export class KitBootstrapButtonGroupExampleComponent {}
